<template lang="pug">
//- MEMO: UI統一後のコンポーネント。
  すべてこちらのUIに移行できたら、'/components/FormTextInput.vue'は削除する。
.m-form-field
  validation-provider(v-slot="{ errors, invalid, validated, required }" :rules="rules" :name="name" tag="div")
    .m-form-label(:class="required ? 'is-required' : 'is-optional'")
      label(:for="label" v-html="title || name")
    .caption(v-if="caption") {{ caption }}
    input(v-if="mask" v-facade="mask" :type="type" :id="label" v-model="currentValue" :placeholder="placeholder" :autocomplete="autocomplete" :class="{ 'is-error': invalid && validated }")
    input(v-else :type="type" :id="label" v-model="currentValue" :placeholder="placeholder" :autocomplete="autocomplete" :class="{ 'is-error': invalid && validated }")
    .error-message(v-if="errors[0]" v-html="errors[0]")
    //- div(v-html="html")
</template>

<script>
import { facade, filter } from 'vue-input-facade'
export default {
  name: 'FormTextInput',
  directives: { facade },
  filters: { facade: filter },
  props: {
    value: {
      type: String,
      default: ''
    },
    vid: {
      type: String,
      default: undefined
    },
    // エラーメッセージ「〇〇は必須項目です」を書き換える。項目タイトルとしても使用可能。
    name: {
      type: String,
      default: ''
    },
    // 項目タイトルのみで使用。
    // タイトル内にHTMLの改行などを追加する場合は、こちらを使用する。
    // エラーメッセージをデフォルトから変更している場合も、こちらを使用する。(nameを設定すると、エラーメッセージが上書きされてしまうため。)
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: ''
    },
    rules: {
      type: [Object, String],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: ''
    },
    mask: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text',
      validator(value) {
        return [
          'url',
          'text',
          'password',
          'tel',
          'search',
          'number',
          'email',
          'date'
        ].includes(value)
      }
    }
  },
  data: () => ({
    currentValue: ''
  }),
  watch: {
    currentValue(val) {
      // allows us to use v-model on our input.
      this.$emit('input', val)
    },
    value(val) {
      if (val !== this.currentValue) {
        this.currentValue = val
      }
    }
  },
  created() {
    if (this.value) {
      this.currentValue = this.value
    }
  }
}
</script>
